<template>
<div class="infomation">
    <div class="infomationTitle">
        <h1 class="topTitle">インフォメーション</h1>
    </div>
    <div class="container">
        <iframe src="https://xs936289.xsrv.jp/ToolInfomation/" scrolling="no" id="frame"></iframe>
    </div>
    
</div>
</template>
<script>

export default {
    data() {
        return {
            loginId:'',
            passwd:'',
            tmp:''
        }
    },
    methods:{
        login(){
            ;
        },
    },
    created(){
            var href = location.href;
            var path = href.split("/");
            path = path[path.length -1];
            console.log(path)
            if(path == 'infomation'){
                window.addEventListener('message', function(e) {
                        var iframe = document.getElementById("frame");
                        var data = e.data[1];
                        iframe.style.height = data+"px";
                        }, false);
                }
        }
}
</script>
<style scoped lang="scss">
</style>